import React from 'react';
import { Provider } from 'react-redux';
import { store } from './app/store';
import Cta from './Cta';
import FormPage from './FormPage';

// Un semplice contenitore per i nostri componenti statici
const StaticContainer = ({ id, children }) => (
  <div id={id} style={{ margin: '20px' }}>
    {children}
  </div>
);

export default function StaticRenderer() {
  return (
    <Provider store={store}>
      <h1>Pagina di Rendering Statico</h1>
      <p>Questa pagina viene usata solo per generare l'HTML.</p>

      <StaticContainer id="static-cta">
        <Cta />
      </StaticContainer>

      <StaticContainer id="static-form-page">
        <FormPage />
      </StaticContainer>
    </Provider>
  );
}